var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 15,
    fill: "#DEDEDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop - 50",
    clipPath: "url(#clip0_3722_1723)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1129 -241)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1707478190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 39441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1707478258"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12.5,
    y: -14.5,
    width: 121,
    height: 44,
    rx: 3.5,
    stroke: "#683C8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.182812 7.05781L6.43281 0.807808C6.52022 0.720301 6.63163 0.660697 6.75293 0.63654C6.87424 0.612384 6.99998 0.624763 7.11424 0.672108C7.22851 0.719453 7.32616 0.799636 7.39483 0.902507C7.46349 1.00538 7.5001 1.12631 7.5 1.25L7.5 13.75C7.5001 13.8737 7.46349 13.9946 7.39483 14.0975C7.32616 14.2004 7.22851 14.2805 7.11424 14.3279C6.99998 14.3752 6.87424 14.3876 6.75293 14.3635C6.63163 14.3393 6.52022 14.2797 6.43281 14.1922L0.182812 7.94218C0.124702 7.88414 0.0786023 7.81521 0.0471497 7.73933C0.015697 7.66346 -0.000491142 7.58213 -0.000491142 7.5C-0.000491142 7.41786 0.015697 7.33653 0.0471497 7.26066C0.0786023 7.18478 0.124702 7.11585 0.182812 7.05781Z",
    fill: "#683C8C"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3722_1723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-1129 -241)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.78d7f4f19e8a06b37483c5350916ac50.svg";
export { ForwardRef as ReactComponent };